// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=CompanyType|schemaHash=c4de504abd9615b47346c69d308366094b438423

import { setDefinedValue } from '@myre/common-primitives';

import { parseTranslationFromJSON, parseTranslationToJSON } from './Translation';

export function parseCompanyTypeFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'name',
    parseTranslationFromJSON(
      _data.name
    ),
  );
  setDefinedValue(result, 'id', _data.id);

  return result;
}

export function parseCompanyTypeToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'name',
    parseTranslationToJSON(
      _data.name
    ),
  );
  setDefinedValue(result, 'id', _data.id);

  return result;
}
